'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFunction;
function isFunction(func) {
  return 'function' === typeof func;
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/isFunction.js
 ** module id = 1241
 ** module chunks = 0
 **/